/*
* include vue
*/
window.Vue = require('vue')

/*
* include lodash
*/
window._ = require('lodash')

/*
* load components list
*/
import {components} from './components'

/*
* load axios
*/
window.axios = require('axios');
window.axios_form_data = require('axios');

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios_form_data.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios_form_data.defaults.headers.common['Content-Type'] = 'multipart/form-data';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
* Echo exposes an expressive API for subscribing to channels and listening
* for events that are broadcast by Laravel. Echo and event broadcasting
* allows your team to easily build robust real-time web applications.
*/

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: '4-belt',
//     // cluster: process.env.PUSHER_APP_CLUSTER,
//     forceTLS: false,
//     wsHost: 'localhost', // server websocket si trova nello stesso server dell'applicazione laravel
//     wsPort: 6001,
//     disableStats: true
// });

/*
* include vue components
*/
document.addEventListener( "DOMContentLoaded", includeComponents);

function includeComponents(){

  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').content;

  var pageName = document.getElementsByTagName("body")[0].dataset.page;
  var pageArea = document.getElementsByTagName("body")[0].dataset.area;

  var included = [];

  // Codice piú compatto

  var keyComponent = ['globals', pageArea, pageName];

  for (let iC in keyComponent ) {

    if( components[keyComponent[iC]] && components[keyComponent[iC]].length > 0 ){

      components[keyComponent[iC]].forEach((item, i) => {

        // check if is not exlcuded component
        if( components.exclusions[item.name] && components.exclusions[item.name].contains(keyComponent[iC]) )
          return;

        Vue.component(
          item.name,
          require('../components/' + item.src).default
        );
        // dev log
        included.push(item.name);

      });

    }

  }

  // console.log('Inizio lista componenti >>');
  // console.log(included);
  // console.log('<< Fine lista componenti');

}
